import { isEqual } from 'lodash'
import { EffectCallback, useEffect, useRef } from 'react'

export const useDeepEffect = (effectFunc: EffectCallback, deps: any[]) => {
  const isFirst = useRef(true)
  const prevDeps = useRef(deps)

  useEffect(() => {
    const isSame = prevDeps.current.every((obj, index) => isEqual(obj, deps[index]))

    if (isFirst.current || !isSame) {
      effectFunc()
    }

    isFirst.current = false
    prevDeps.current = deps
  }, [effectFunc, deps])
}
